import classNames from 'classnames';
import React from 'react';

export interface PageTitleProps {
  text?: string | JSX.Element;
  subText?: string | JSX.Element;
  className?: string;
}

export const PageTitle = (props: React.PropsWithChildren<PageTitleProps>) => {
  if (props.text) {
    return (
      <>
        <h1 className={classNames('page-header d-flex', props.className)}>
          {props.text}
          {props.children ? props.children : <></>}
        </h1>
        {props.subText && <div className="page-subheader">{props.subText}</div>}
      </>
    );
  }
  return <>{props.children ? props.children : <></>}</>;
};
